import React, {Component} from 'react';
import {connect} from 'react-redux';
import ChatWindow from './ChatWindow/ChatWindow';
import { inject, observer } from 'mobx-react'

class ChatWindows extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  renderWindows() {
    const chatWindows=this.props.chatStore.opened_windows.map((item)=>{
      return (
        <div className="cell s-shrink s-end" key={item}>
          <ChatWindow chat_id={item} />
        </div>
      );
    });
    if(chatWindows) {
      return (
        <div className="up12 splice">
          {chatWindows}
        </div>
      )
    } else {
      return null;
    }
  }
  render() {
    if(!this.props.meStore.me.data) {
      return null;
    }
    return (
      <div className="pf pa-br" style={{zIndex:100}}>
        {this.renderWindows()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    chat_opened_windows:state.chat_opened_windows,
    me:state.me,
  }
}

// export default connect(mapStateToProps)(ChatWindows);
export default inject("meStore","chatStore")(observer(ChatWindows));